class SubscriptionAlert implements ng.IComponentController {
    saTitle: string;
    content: string;
    buttonName: string;
    onClick: () => void;
}

angular.module('animatronApp.SubscriptionAlert', [])
    .component('subscriptionAlert', {
        bindings: {
            saTitle: '<',
            content: '<',
            buttonName: '<',
            onClick: '&'
        },
        controller: SubscriptionAlert,
        templateUrl: require('settings/subscription/subscription-alert.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionAlert.ts